<template>
  <section id="top" class="hero-section">
    <div class="hero-copy" v-reveal>
      <p class="section-kicker">{{ hero.kicker }}</p>
      <h1>
        <span v-for="line in hero.titleLines" :key="line">{{ line }}</span>
      </h1>
      <p class="hero-text">{{ hero.copy }}</p>
      <div class="hero-actions">
        <a class="action-button action-button--discord action-button--large" :href="hero.primaryAction.href">
          <AppIcon :name="hero.primaryAction.icon" />
          <span>{{ hero.primaryAction.label }}</span>
        </a>
        <a class="action-button action-button--muted action-button--large" :href="hero.secondaryAction.href">
          <AppIcon :name="hero.secondaryAction.icon" />
          <span>{{ hero.secondaryAction.label }}</span>
        </a>
      </div>
    </div>

    <div class="hero-visual" v-reveal>
      <div class="hero-glow hero-glow--blue"></div>
      <div class="hero-glow hero-glow--violet"></div>
      <MascotLogo />
      <div class="orbit orbit--one"></div>
      <div class="orbit orbit--two"></div>
    </div>
  </section>
</template>

<script>
import AppIcon from './AppIcon.vue'
import MascotLogo from './MascotLogo.vue'

export default {
  name: 'HeroSection',
  components: {
    AppIcon,
    MascotLogo
  },
  props: {
    hero: {
      type: Object,
      required: true
    }
  }
}
</script>
